import { injectable, interfaces } from 'inversify';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'wouter';
import { uuid } from '../CodesThatsGottaGoSomewhereElse';
import { defineCommand } from '../concepts/commands/CommandDefinition';
import { useResolve } from './Container';


export const AppNavigator = Symbol('AppNavigator') as interfaces.ServiceIdentifier<Navigator>;

/**
 * Provides the ability to navigate between different high level application states (pages).
 */
export interface Navigator {
    go(to: string): void;
    go(to: string[]): void;
}

@injectable()
export class NavigatorDriver implements Navigator {

    private backend?: (href: string) => void;

    public connect(callback: (href: string) => void) {
        this.backend = callback;
        return () => this.backend = null;
    }

    public go(to: string | string[]) {
        if (this.backend) {
            this.backend(toHref(to));
        }
    }
}

export const NavigatorSupport = () => {
    const driver = useResolve(AppNavigator) as NavigatorDriver;
    const [key, setKey] = useState(uuid());
    const [href, setHref] = useState('');
    useEffect(() => driver.connect(x => {
        setHref(x);
        setKey(uuid());
    }), []);
    return href ? <Redirect key={key} to={href} /> : <></>;
};

const toHref = (input: string | string[]) => Array.isArray(input) ? '/' + input.join('/') : input;

export const goto = defineCommand(
    'goto',
    'Goto: Path',
    (r, [to]: [string]) => r.call(AppNavigator).go(to)
);
